import { defineAsyncComponent } from 'vue'
import { clearPokerPreflightData, getPokerPreflightData, setPokerPreflightData } from 'hooks/usePoker.js'
import { useModalsStore } from 'stores/modals'
import { $apollo } from 'src/apollo/apollo-options-api'
import { consoleLogAPI } from 'src/common/functions'
import getLppToken from '@/apollo/queries/getLppToken.gql'

export const POKER_BONUS_RESTRICTION_STATUS = 'DISABLED_BY_PROMO'

async function loadPokerInit() {
  const { data } = await $apollo.query({
    query: getLppToken,
    fetchPolicy: 'network-only',
  })

  return data?.lppInit ?? null
}

export function showPokerBonusRestrictionModal() {
  useModalsStore().pushModal({
    componentName: defineAsyncComponent(() => import('components/poker/PokerBonusRestrictionModal.vue')),
  })
}

function restoreLiveChatVisibility(route) {
  const isLiveChatHidden = route.matched?.some((record) => record.meta.isLiveChatHidden) ?? route.meta?.isLiveChatHidden
  document.body.classList.toggle('lc-hidden', Boolean(isLiveChatHidden))
}

function getHomeRoute(to) {
  const locale = to.params?.locale

  return {
    name: 'Home',
    ...(locale ? { params: { locale } } : {}),
  }
}

export function createPokerBeforeEnter({
  fetchPokerInit = loadPokerInit,
  showRestrictionModal = showPokerBonusRestrictionModal,
  setPreflightData = setPokerPreflightData,
  getPreflightData = getPokerPreflightData,
  clearPreflightData = clearPokerPreflightData,
  reportError = consoleLogAPI,
  restoreLiveChat = restoreLiveChatVisibility,
} = {}) {
  return async function pokerBeforeEnter(to, from, next) {
    const currentPreflightData = getPreflightData()
    clearPreflightData()

    const blockPokerNavigation = () => {
      if (from.name != null) {
        restoreLiveChat(from)
        return next(false)
      }

      return next(getHomeRoute(to))
    }

    try {
      const lppInit = currentPreflightData ?? (await fetchPokerInit())

      if (lppInit?.statusCode === POKER_BONUS_RESTRICTION_STATUS) {
        showRestrictionModal()
        return blockPokerNavigation()
      }

      if (lppInit) {
        setPreflightData(lppInit)
      }
    } catch (error) {
      reportError(error)
    }

    return next()
  }
}

export const pokerBeforeEnter = createPokerBeforeEnter()
